const BASIS_POINTS_SCALE: bigint = BigInt(10_000);
const ZERO: bigint = BigInt(0);

export function formatBackerVaultShare(backedD6: string, totalD6: string, locale: string): string {
  const total = BigInt(totalD6);
  // Match mobile's two-decimal percentage precision before display rounding.
  const basisPoints = total === ZERO ? ZERO : (BigInt(backedD6) * BASIS_POINTS_SCALE) / total;
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(Number(basisPoints) / Number(BASIS_POINTS_SCALE));
}
